export default __webpack_public_path__ + "img/accha/accha6.webm";